<div class="d-flex flex-column gap-2">
  <div class="fund-indicator-name-container">
    <div class="indicator" [style.background-color]="indicatorColour"></div>
    <div class="fund-name">{{ fundName }}</div>
  </div>
  <div class="fund-value" i18n>Balance: {{ balance | currency }}</div>
</div>
